import Vue from 'vue'
import Util from '@/common/Util';
import Task from '@/common/Task';
import * as DateTime from '@/common/DateTime';

//the StoreGraph stores the task and edge data; cytoscape only records their uuid and display info
export const storeGraph = {
  state: {
    name: 'storeGraph',
    tasks: [],//task [name, number, uuid] are unique
    edges: [] //{uuid: Util.uuidv4(), source: tp.uuid, target: tc.uuid};
  },
  getters: { //store getters CANNOT have arguments, logic shifted into Graph
    getTasks(state){
      //ensure tasks are Task
      return state.tasks;
    },
    getNewTaskNumber( state ){
      return state.tasks.length; //length is +1 == new task number
    },
    getEdges(state){
      return state.edges;
    }
  },
  mutations: { //setters CANNOT return values
    clearStore(state){
      state.tasks = [];
      state.edges = [];
    },
    addTask(state, newTask) {
      //ensure task is unqiue

      let uniq = true;
      state.tasks.forEach( (t, ind)=>{
        if (t.uuid == newTask.uuid || t.name == newTask.name ){
          uniq = false;
        }
      });

      if (uniq){
        state.tasks.push( newTask );
      } else {
        Vue.$log.info('storeGraph: [' + newTask.uuid +': ' + newTask.name + '] is already present'); //use fields
      }
      // Vue.$log.info('storeGraph.addTask: added new task[' + newTask.toString() + '], have [' + state.tasks.length +'] tasks');
      // Vue.$log.info('storeGraph.addTask: added new task[' + newTask.uuid + ' : ' + newTask.toString() + ']');
      // Vue.$log.info('storeGraph.addTask: added new task[' + newTask.uuid + ' : ' + newTask.name + ' : ' + newTask.dateDue + ' : ' + newTask.pctDone +  ']');
    },
    updateTask(state, changedTask){
      let newtasks = [];
      for (let t of state.tasks){
        if( t.uuid == changedTask.uuid){
          // console.log('updated t[' + t.toString() + '] to [' + changedTask.toString() + ']' );
          newtasks.push(changedTask);
        } else {
          newtasks.push(t);
        }
      }
      state.tasks = newtasks;
    },
    // upgradeTasks(state){
    //   let newtasks = []
    //   state.tasks.forEach( (t, ind) =>{
    //     if ( !(t instanceof Task) ){
    //       // console.log('upgardeTasks, told', t);
    //       let tnew = new Task( t.name );
    //       tnew.dateAdded = t.dateAdded;
    //       tnew.dateDue = t.dateDue;
    //       tnew.hoursPlanned = t.hoursPlanned;
    //       tnew.num = ind;
    //       tnew.pctDone = t.pctDone;
    //       tnew.uuid = t.uuid;
    //       // this[ind] = tnew; //assign Task object over json
    //       // console.log('upgradeTasks, tnew', tnew);
    //       newtasks.push( tnew );
    //     } else {
    //       newtasks.push( t );
    //     }
    //     state.tasks = newtasks;
    //   });
    // },
    renumberTasks( state ){
      let newtasks = []
      state.tasks.forEach( (t, ind) =>{
        // this[ind].num = ind;
        t.num = ind;
      });
    },
    puntTask(state, taskUUID){
      state.tasks.forEach( (t,ind)=>{
        if (t.uuid == taskUUID){
          let newd = DateTime.addTime( DateTime.getNow(), {month: 1} );
          // console.log('dateTime', {was: t.dateDue, newd:newd});
          t.dateDue = newd;
        }
      });
    },
    delTask(state, taskUUID){
      //locate task index
      let itask = -1;
      for (let it=0; it < state.tasks.length; it++){
        if (state.tasks[it].uuid == taskUUID){
          itask = it;
        }
      }

      //find edges that will be broken, remake edges array
      let ups = [];//array of (grand)parents of taskUUID
      let ucs = [];//array of children of taskUUID
      let unmod = []; //array of unmodified edges
      state.edges.forEach( (ed, ind) => {
        if (ed.source == taskUUID){ //ed.target is a child
          ucs.push( ed.target );
          // ucs.push( {uuid: ed.target, index: ind} );
        } else if (ed.target == taskUUID){ //ed.source is a parent
          ups.push( ed.source );
          // ucs.push( {uuid: ed.source, index: ind} );
        } else { // edge is unaffected
          unmod.push(ed);
        }
      });

      //connect grandparents to children
      for (let up of ups){
        for (let uc of ucs){
          let ed = {id: Util.uuidv4(), source: up, target: uc };
          unmod.push( ed );
        }
      }

      state.tasks.splice( itask, 1 ); //remove the task
      state.edges = unmod;
    },

    addEdge(state, edge) {
      //ensure uuids exist
      let existSource = false;
      let existTarget = false;
      for (let t of state.tasks){
        if (t.uuid == edge.source){
          existSource = true;
        }
        if (t.uuid == edge.target){
          existTarget = true;
        }
      }
      let uniq = true;
      state.edges.forEach( (e, ind)=>{
        if ( e.source == edge.source && e.target == edge.target){
          uniq = false;
        }
      });

      if (existSource && existTarget && uniq){
        state.edges.push( edge );
      // Vue.$log.info('storeGraph.addEdge: added new edge:', edge );
      } else {
        Vue.$log.info('addEdge: source[' + existSource + '] or target[' + existTarget +'] do not exist', edge);
      }
    },
    delEdge(state, edgeUUID ) {
      let ind = -1;
      for (let ie = 0; ie < state.edges.length; ie++){
        if (state.edges[ie].uuid == edgeUUID){
          ind = ie;
        }
      }

      if (0 <= ind){
        let ret = state.edges.splice(ind, 1);
        // console.log('found edge at index' + ind, ret);
      } else {
        console.log('didnt find edge[' + edgeUUID +']');
      }
    }//delEdge
  },
  actions: {
    upgradeTasks({state,commit,rootState}){

      let newtasks = []
      state.tasks.forEach( (t, ind) =>{
        if ( !(t instanceof Task) ){
          // console.log('upgardeTasks, told', t);
          let tnew = new Task( t.name );
          tnew.dateAdded = t.dateAdded;
          tnew.dateDue = t.dateDue;
          tnew.hoursPlanned = t.hoursPlanned;
          tnew.num = ind;
          tnew.pctDone = t.pctDone;
          tnew.uuid = t.uuid;
          // this[ind] = tnew; //assign Task object over json
          // console.log('upgradeTasks, tnew', tnew);
          newtasks.push( tnew );
        } else {
          newtasks.push( t );
        }
        state.tasks = newtasks;
      });
    }, //upgradeTasks

  }
}
